import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
	selector: 'app-ai-advisor-assistant',
	templateUrl: './ai-advisor-assistant.component.html',
	styleUrls: ['./ai-advisor-assistant.component.scss']
})
export class AiAdvisorAssistantComponent implements OnInit {
  @Input() selected_opportunity_period: any;
  @Output() stateChanged = new EventEmitter<any>();

  constructor(
    public commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.tabChange(this.selected_digital_advisor_tab);
  }

  // selected_digital_advisor_tab: any = 'Unassigned Clients';
  // selected_digital_advisor_tab: any = 'Assigned Clients';
  selected_digital_advisor_tab: any = 'Clients';

  tabChange(value) {
    this.selected_digital_advisor_tab = value;
    // this.getTabCount();
  }

  tab_count_data: any = {
    unassigned_clients: 0,
    assigned_clients: 0,
    assigned_prospects: 0,
  };
  getTabCount() {
    this.commonService.getData('/reassignmentstepcount/' + "?opp_year=" + this.selected_opportunity_period).subscribe(
      (res: any) => {
        this.tab_count_data = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		this.stateChanged.emit(data);
	}

  description_sections: any = [
    {
      name: "This section is designed to enhance the efficiency and effectiveness of advisors by leveraging AI technology:",
      sub_sections: [
        {
          name: "Section Purpose",
          // value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the AI Advisor Assistant. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
          value: "This section is created to identify clients within an advisor's book of business who are suitable candidates for reassignment to the MAGI. The objective is to streamline the advisor's workflow, significantly reducing daily tasks by 30 to 60%."
        },
        {
          name: "Benefits of Reassignment",
          // value: "By reallocating certain clients to the AI Advisor Assistant, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
          value: "By reallocating certain clients to the MAGI, advisors can optimize their schedules, allowing them to expand their clientele and elevate the quality of service offered to existing clients. This transition is designed to retain the full spectrum of service benefits while simultaneously granting advisors additional bandwidth for client engagement and business development."
        },
        {
          // name: "AI Advisor Assistant Capabilities",
          name: "MAGI Capabilities",
          // value: "The AI Advisor Assistant is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
          value: "The MAGI is an advanced system, an amalgam of various AI models, each specializing in distinct areas of client management. These models include:",
          sub_sections: [
            {
              name: "Best Client Interaction Strategy",
              value: "Tailored communication tactics to engage clients effectively."
            },
            {
              name: "Upside Opportunities Identification",
              value: "Recognition of potential areas for financial growth within the client's portfolio."
            },
            {
              name: "Retention Risk Analysis",
              value: "Detection of signals that may indicate a client is at risk of ending their services."
            },
          ]
        },
        {
          name: "Training and Performance",
          value: "This feature has undergone extensive training, modeling its approach on the patterns and strategies of high-performing advisors. It analyzes how successful advisors respond to leads and manage retention risks, applying these best practices autonomously to manage routine tasks and client interactions."
        },
        {
          name: "Automation and Efficiency",
          // value: "The AI Advisor Assistant is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
          value: "The MAGI is a testament to the power of automation, embodying the capability to take over a substantial portion of the advisor's operational duties. This allows for a more focused and strategic allocation of the advisor's time and expertise, ensuring that clients receive top-tier advisory services while the advisor's practice becomes more scalable and efficient."
        },
      ]
    },
  ];
}
